import React from "react";
import { connect } from "react-redux";

import { fetchUrl } from "../../config/utils";
import { setAccount } from "../../store";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUserPlus,
    faUser,
    faLock,
    faEnvelope,
    faEye,
    faEyeSlash,
    faCheck,
    faArrowLeft,
    faSignInAlt
} from "@fortawesome/free-solid-svg-icons";

import style from "./style.scss";

const EMAIL_RE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const NAME_RE = /^[a-zA-Z0-9_]+$/;

class RegisterForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            password: "",
            repassword: "",
            email: "",
            errors: {},
            showPassword: false,
            submitting: false,
            serverError: ""
        };
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    validate = (state = this.state) => {
        const { name, password, repassword, email } = state;
        const errs = {};
        if (name) {
            if (name.length < 3) errs.name = "Mínimo 3 caracteres";
            else if (name.length > 20) errs.name = "Máximo 20 caracteres";
            else if (!NAME_RE.test(name))
                errs.name = "Solo letras, números y guion bajo";
        }
        if (password) {
            if (password.length < 4) errs.password = "Mínimo 4 caracteres";
        }
        if (repassword) {
            if (repassword !== password)
                errs.repassword = "Las contraseñas no coinciden";
        }
        if (email) {
            if (!EMAIL_RE.test(email.toLowerCase()))
                errs.email = "Email inválido";
        }
        return errs;
    };

    handleInput = e => {
        const { name, value } = e.target;
        const nextState = { ...this.state, [name]: value, serverError: "" };
        nextState.errors = this.validate(nextState);
        this.setState(nextState);
    };

    toggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    handleSave = async e => {
        if (e && e.preventDefault) e.preventDefault();

        const { name, password, repassword, email, submitting } = this.state;
        if (submitting) return;

        const errs = this.validate();
        if (!name) errs.name = "Requerido";
        if (!password) errs.password = "Requerido";
        if (!repassword) errs.repassword = "Requerido";
        if (!email) errs.email = "Requerido";

        if (Object.keys(errs).length > 0) {
            this.setState({ errors: errs });
            return;
        }

        this.setState({ submitting: true, serverError: "" });

        try {
            const result = await fetchUrl("/register", {
                method: "POST",
                body: JSON.stringify({
                    name,
                    password,
                    email: email.toLowerCase()
                }),
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            });

            if (this._unmounted) return;

            if (result.error) {
                this.setState({
                    submitting: false,
                    serverError: result.message || "Error al registrar"
                });
                return;
            }

            this.props.dispatch(setAccount(result));
            if (this.props.onSuccess) this.props.onSuccess();
        } catch (err) {
            if (this._unmounted) return;
            this.setState({
                submitting: false,
                serverError: "Error de red. Intentá de nuevo."
            });
        }
    };

    renderField = ({
        label,
        name,
        type = "text",
        icon,
        placeholder,
        autoComplete,
        helper
    }) => {
        const { errors, [name]: value, showPassword } = this.state;
        const isPassword = type === "password";
        const inputType = isPassword && showPassword ? "text" : type;
        const err = errors[name];
        const ok = !err && value && value.length > 0;

        return (
            <div className={style.field}>
                <label className={style.fieldLabel}>{label}</label>
                <div
                    className={`${style.inputWrap} ${err ? style.inputErr : ""} ${ok ? style.inputOk : ""}`}
                >
                    <FontAwesomeIcon icon={icon} className={style.fieldIcon} />
                    <input
                        type={inputType}
                        name={name}
                        value={value}
                        onChange={this.handleInput}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        className={style.input}
                        maxLength={name === "name" ? 20 : 100}
                    />
                    {isPassword && (
                        <button
                            type="button"
                            className={style.iconBtn}
                            onClick={this.toggleShowPassword}
                            tabIndex={-1}
                            title={
                                showPassword
                                    ? "Ocultar contraseña"
                                    : "Mostrar contraseña"
                            }
                        >
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                            />
                        </button>
                    )}
                    {ok && !isPassword && (
                        <FontAwesomeIcon
                            icon={faCheck}
                            className={style.okIcon}
                        />
                    )}
                </div>
                {err ? (
                    <span className={style.errorMsg}>{err}</span>
                ) : helper ? (
                    <span className={style.helpMsg}>{helper}</span>
                ) : null}
            </div>
        );
    };

    render() {
        const { errors, submitting, serverError, name, password, repassword, email } = this.state;
        const { onSwitchToLogin } = this.props;

        const allFilled = name && password && repassword && email;
        const noErrors = Object.keys(errors).length === 0;
        const canSubmit = allFilled && noErrors && !submitting;

        return (
            <form
                className={style.card}
                onSubmit={this.handleSave}
                noValidate
            >
                <div className={style.cardBody}>
                    {this.renderField({
                        label: "Usuario",
                        name: "name",
                        icon: faUser,
                        placeholder: "Ej. juan_perez",
                        autoComplete: "username",
                        helper: "3-20 caracteres, letras, números y _"
                    })}

                    {this.renderField({
                        label: "Contraseña",
                        name: "password",
                        type: "password",
                        icon: faLock,
                        placeholder: "Mínimo 4 caracteres",
                        autoComplete: "new-password",
                        helper: "Elegí algo que solo vos recuerdes"
                    })}

                    {this.renderField({
                        label: "Repetir contraseña",
                        name: "repassword",
                        type: "password",
                        icon: faLock,
                        placeholder: "Re-escribí tu contraseña",
                        autoComplete: "new-password"
                    })}

                    {this.renderField({
                        label: "Email",
                        name: "email",
                        type: "email",
                        icon: faEnvelope,
                        placeholder: "tu@correo.com",
                        autoComplete: "email",
                        helper: "Para recuperar tu cuenta"
                    })}

                    {serverError && (
                        <div className={style.serverError}>{serverError}</div>
                    )}
                </div>

                <div className={style.cardFooter}>
                    <button
                        type="submit"
                        className={style.submitBtn}
                        disabled={!canSubmit}
                    >
                        {submitting ? "Creando cuenta..." : "Registrarse"}
                    </button>
                    {onSwitchToLogin && (
                        <button
                            type="button"
                            className={style.switchLogin}
                            onClick={onSwitchToLogin}
                        >
                            <FontAwesomeIcon icon={faSignInAlt} />
                            <span>¿Ya tenés cuenta? Iniciar sesión</span>
                        </button>
                    )}
                    <p className={style.fineprint}>
                        Al registrarte aceptás respetar las reglas del servidor.
                    </p>
                </div>
            </form>
        );
    }
}

export default connect()(RegisterForm);
